import { createReducer } from '@reduxjs/toolkit';
import { defaultActionFail, defaultActionStart, getActionStringWithoutState, setDefaultStart } from '@redux/reduxUtils';
import { fetchPromptAction } from './promptsActions';
import { PromptsState } from './promptsTypes';

export const initialPromptsState: PromptsState = {
  isLoading: {},
  error: {},
  success: {},
  promptList: []
};

export default createReducer(initialPromptsState, (builder) => {
  builder
    .addCase(fetchPromptAction.start, defaultActionStart)
    .addCase(fetchPromptAction.fail, defaultActionFail)
    .addCase(fetchPromptAction.success, (state, action) => {
      const promptTag = getActionStringWithoutState(action.type);
      state.isLoading[promptTag] = false;
      state.promptList = action.payload ?? [];
    });
});
